export default "__VITE_ASSET__CK9J2lVv__"